enum ArticleStatus {
    UNPUBLISHED = 'unpublished',
    SCHEDULED = 'scheduled',
    PUBLISHED = 'published',
}

export default ArticleStatus